import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { COGS, DateRange, OperatingExpenses, Transaction } from '@contracts/interfaces/transaction.interfaces';
import { ACCOUNT } from 'src/app/accounts';
import { TransactionsService } from 'src/app/services/transactions.service';

export interface DialogData {
    dateRange: {
        start: Date,
        end: Date
    }
}

@Component({
    selector: 'app-expenses-tax-figures.dialog',
    templateUrl: './expenses-tax-figures.dialog.html',
    styleUrls: ['./expenses-tax-figures.dialog.scss', '../common-dialog-styles.scss']
})
export class ExpensesTaxFiguresDialogComponent {

    public dateRange: DateRange = null;

    public atoCategorieTotals = [];
    totalExpenseExcl = 0;
    totalRevenueExcl = 0;
    expenses: any[] = [];
    
    public totalRevenueIncl: number = 0;
    public gstOnSales: number = 0;
    public gstOnExpenses: number = 0;

    catIndex: any[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<ExpensesTaxFiguresDialogComponent>,
        public transactionService: TransactionsService
    ) {
        this.dateRange = data.dateRange;
    }

    ngOnInit() {
        this.calcExpenses();
    }



    calcExpenses () {
        let temp = {};
        let query = {};
        
    
        query["$or"] = [ 
            {"source.account": ACCOUNT.EXPENSES}, 
            {"source.account": ACCOUNT.G72EXPENSES} 
          ];

        query["ignore"] = { "$in": [null, false] };
    
        temp["$gte"] = this.dateRange.start;
        temp["$lte"] = this.dateRange.end;
    
        query["date"] = temp;
    
        this.transactionService.find(query, null, null, {"description": 1}).subscribe((results: Transaction[]) => {
          let temp = [];
          // this.info.count = 0;
          // this.info.amount = 0;
          // this.info.vat = 0;
    
          for (let i=0;i<results.length;i++) {
            this.setCatIndex(results[i]["atocategory"]);
          }
    
          for (let i=0;i<results.length;i++) {
            //this.info.count++;
    
            let catIndex = this.getCatIndex(results[i]["atocategory"]);
    
            if (temp[catIndex] == undefined) {
              temp[catIndex] = [];
            }
    
            temp[catIndex].push(results[i]);
    
            if (results[i].amount < 0) {
              // Do the GST part
              if (results[i].vat) {
                this.totalExpenseExcl += results[i].amount - (results[i].amount / 11);
                //this.info.amount += results[i].amount - (results[i].amount / 11);
                this.gstOnExpenses += Math.abs(results[i].amount / 11);
                //this.info.vat += Math.abs(results[i].amount / 11);
              } else {
                this.totalExpenseExcl += results[i].amount;
                //this.info.amount += results[i].amount;
              }
            }
          }
    
          this.expenses = temp;
    
          for (let category in temp) {
    
            let calc = 0;
            for (let x of temp[category]) {
              // Do the GST part
              if (x.vat) {
                calc += x.amount - (x.amount/11);
              } else {
                calc += x.amount;
              }
            }
            
            this.atoCategorieTotals.push({
              "category": this.catIndex[category],
              "amount": calc
            });
          }
    
          let check = 0;
          for (let x of this.atoCategorieTotals) {
            check += x.amount;
          }

        });
      }
    


      setCatIndex(category: string | undefined) {
        if (category == undefined) {
          category = "unset"
        }
    
        // Check if category already exists
        for (let cat of this.catIndex) {
          if (cat == category) {
            return;
          }
        }
        
        this.catIndex.push(category);
      }
    
      getCatIndex(category: string | undefined) {
        if (category == undefined) {
          category = "unset";
        }
    
        for (let i=0; i < this.catIndex.length;i++) {
          if (this.catIndex[i] == category) {
            return i;
          }
        }
      }

      getCategoryName(category: string) {
        for (let cogs of COGS) {
            if (cogs.value == category) return cogs.label;
        }

        for (let oe of OperatingExpenses) {
            if (oe.value == category) return oe.label;
        }

        return "Unset";
      }

}
